import { Basket, WarningCircle } from '@phosphor-icons/react';
import { Icon, Surface, cn } from '@shh/ui';
import { useNavigate } from 'react-router';
import { useShopping } from '../data/shopping';
import { kitchenText } from '../i18n/kitchen';

/** "Heute" and the wall: what is on the list at a glance; a tap opens it under "Essen". */
export function ShoppingCard({ className }: { className?: string }) {
  const list = useShopping();
  const navigate = useNavigate();
  const n = list.open.length;
  return (
    <Surface className={cn('relative flex items-center gap-gap-md', className)}>
      <Icon icon={Basket} size="lg" weight="duotone" className="shrink-0 text-accent-primary" />
      <div className="flex min-w-0 flex-1 flex-col">
        <h3 className="font-display text-lg font-black">
          <button
            type="button"
            onClick={() => void navigate('/essen')}
            className="cursor-pointer text-left outline-none after:absolute after:inset-0 after:rounded-card focus-visible:after:outline-3 focus-visible:after:outline-border-focus"
          >
            {kitchenText.shoppingList} {n > 0 && <span className="tabular-nums">· {n}</span>}
          </button>
        </h3>
        <span className="truncate text-sm text-text-secondary">
          {n ? list.open.map((i) => i.name).join(', ') : kitchenText.allThere}
        </span>
      </div>
      {list.error && (
        <Icon icon={WarningCircle} size="md" className="shrink-0 text-feedback-warning" />
      )}
    </Surface>
  );
}
